import React, { Component } from 'react';
import PanelLink from "../../widgets/PanelLink";
import queryString from "query-string";
import { observer } from 'mobx-react';


const CertifedPanelLink = function (props) {
    let timesheets = props.store.timesheets.collection.filter(timesheet => timesheet.isFinal);

    let timesheetNumber = timesheets.length;

    //Get count of uncertified timesheets
    let certifiedNumber = timesheets.reduce(
        (acc, currentTimesheet) => currentTimesheet.isCertified ? acc + 1 : acc,
        0
    );


    return (
        <PanelLink path={`/staff/KronosReport`}>
            <div>
                <span className="panelLinkLarge">{certifiedNumber}</span>
                <span className="panelLinkSmall">/{timesheetNumber}</span>
            </div>
            <span>
                Certified
            </span>
            <span>
                Timesheets
            </span>
        </PanelLink>
    )
}

export default observer(CertifedPanelLink);